export const LEG_FILE_MIMETYPES =
  'application/pdf,text/plain,image/jpeg,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
export const SPEC_FILE_MIMETYPES = 'application/pdf,';
